@if (step() === 'code') {
  <section mat-dialog-title>
    <span>Enter your current code</span>
    <button mat-dialog-close>
      <i class="icon-close"></i>
    </button>
  </section>
  <mat-dialog-content>
    <p class="mb-4">Enter the 6-digit code from your authenticator app.</p>
    <avs-totp-code
      (valueChange)="onTokenChange($event)"
      [invalid]="!!store.error()"
    />
    @if (store.error()) {
      <p class="mt-1 text-ui-red-50">{{ store.error() }}</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-transparent btn-medium font-bold mr-4"
      mat-dialog-close
    >
      CANCEL
    </button>
    <button
      class="btn-green btn-medium font-bold"
      (click)="verify()"
      [disabled]="!isCodeComplete() || store.isPending()"
    >
      @if (store.isPending()) {
        <mat-spinner
          class="mr-1"
          diameter="20"
        ></mat-spinner>
      }
      VERIFY
    </button>
  </mat-dialog-actions>
}

@if (step() === 'confirm') {
  <section mat-dialog-title>
    <span>Reset 2FA?</span>
    <button mat-dialog-close>
      <i class="icon-close"></i>
    </button>
  </section>
  <mat-dialog-content>
    <p>This will replace your current authenticator with a new one. Your existing 2FA stays active until you finish setting up the new one.</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button
      class="btn-transparent btn-medium font-bold mr-4"
      mat-dialog-close
    >
      CANCEL
    </button>
    <button
      class="btn-green btn-medium font-bold"
      (click)="startReplacement()"
    >
      RESET
    </button>
  </mat-dialog-actions>
}
